import React from "react";

import "../../scss/molecules/_link-list.scss";

class LinkList extends React.Component {
  render() {
    return (
      <ul
        className={
          "link-list" + (this.props.className ? " " + this.props.className : "")
        }
      >
        {this.props.children}
      </ul>
    );
  }
}

export default LinkList;
